/*
 * N49 Framework
 * 2020-2021
 */

(function ($) {

    let N49 = {

        debug: false,
        ajaxURL: "//" + location.host + "/wp-admin/admin-ajax.php",

        init: function (debug = false) {

            this.debug = debug;
            this.handle__accordion();
            this.handle__tiles();
            this.handle__menu();
            this.handle__ajax();
            this.handle__videos();
            this.handle__masonry();
            this.handle__archive();

        },
        handle__tiles: function () {
            if (window.matchMedia("(max-width: 890px)").matches) {
                $('.header-bottom-items .row').not('.slick-initialized').slick({
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    swipe: false,
                    centerMode: false,
                    variableWidth: false,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {swipe: true, infinite: true, slidesToShow: 1, slidesToScroll: 1,},
                        }
                    ],
                });
            }
        },
        handle__ajax: function () {
            $('.js--archive-ajax').ajaxArchive({
                ajax_base_url: N49.ajaxURL,
            });

        },
        handle__accordion: function () {

            var acc = document.getElementsByClassName("js--accordion");
            var i;

            for (i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    var panel = this.nextElementSibling;
                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    }
                });
            }


        },
        handle__menu: function () {


            // Search

            const searchBtn = $(".js--search-btn");
            const exitBtn = $(".js--exit-btn");
            const searcInput = $(".header .js--search-box");
            const headerMenu = $(".js--header-menu");

            searchBtn.click(function() {
                searchBtn.toggleClass( "is-active" );
                headerMenu.toggleClass( "is-active" );
                searcInput.toggleClass( "is-active" );
            });

            exitBtn.click(function() {
                searcInput.removeClass( 'is-active' );
                setTimeout(() => {
                    searchBtn.removeClass( 'is-active' );
                    headerMenu.removeClass( 'is-active' );
                }, 500); // Input width animation duration + 200 ms
            });


            // mobile menu

            const mobileMenuOpenBtn = document.querySelector(".js--menu-btn");
            const mobileMenuCloseBtn = document.querySelector(".js--close-btn");
            const mobileMenu = document.querySelector(".js--mobile-menu");

            const mobileSearchBtn = document.querySelector(".js--mobile-search-btn");
            const mobileSearchContent = document.querySelector(".js--search-content");

            const mobileSearchContentJQuery = $(".js--search-content");
            const mobileSearchInput = $('.js--searchInputMobile');

            mobileMenuOpenBtn.addEventListener("click", () => {
                mobileMenu.style.left = "0";
            });
            mobileMenuCloseBtn.addEventListener("click", () => {
                mobileMenu.style.left = "100%";
            });

            const searchInputMobile = document.querySelector(".js--searchInputMobile");

            mobileSearchBtn.addEventListener("click", () => {
                mobileSearchContent.style.right = "0";
                searchInputMobile.focus();
            });

            const mobileSearchExit = $('.js--exit-btn-mobile');

            mobileSearchExit.click(function () {
                if (mobileSearchInput.val().length === 0 ) {
                    mobileSearchContentJQuery.css({ 'right' : '' });
                } else {
                    mobileSearchExit.parent().submit();
                }
            });

            mobileSearchInput.focusout(function () {
                mobileSearchContentJQuery.css({ 'right' : '' });
            }

            );


            function closeMobileInput() {
                mobileSearchContent.style.right = "100%";
            }

            // Mobile Mega Menu

            $('.js--mobile-menu .menu-item-has-children').each(function () {

                $(this).addClass('js--mobile-mega-menu');
                $(this).find('.sub-menu').addClass('js--mobile-mega-menu-content');
                $(this).find('> a').click(function (e) {
                    e.preventDefault();
                    $(this).parent().toggleClass('active');
                });
            });



            document.body.addEventListener('keyup', (e) => {
                if (e.key == "Escape") {
                    searcInput.removeClass( 'is-active' );
                    setTimeout(() => {
                        searchBtn.removeClass( 'is-active' );
                        headerMenu.removeClass( 'is-active' );
                    }, 500); // Input width animation duration + 200 ms
                }
            });


            // Mega Menu


            const megaMenuItem = $(".js--mega-menu");
            const megaMenuContent = $(".js--mega-menu-content");
            const megaMenuContentItems = $(".js--mega-menu-content ul li");

            megaMenuItem.each(function() {
                $(this).mouseenter(function () {
                    $(this).toggleClass('active');
                    $(this).find('.js--mega-menu-content').css('height','auto');
                });

                $(this).mouseleave(function () {
                    $(this).toggleClass('active');
                    $(this).find('.js--mega-menu-content').css('height','0');
                });
            });

            megaMenuContent.each(function() {
                $(this).mouseenter(function () {
                    $(this).toggleClass('active');
                    $(this).find('.js--mega-menu-content').css('height','auto');
                });
            });

            megaMenuContentItems.each(function() {
                $(this).mouseenter(function () {
                    $(this).find('ul').toggleClass('active');
                });

                $(this).mouseleave(function () {
                    $(this).find('ul').toggleClass('active');
                });
            });











            // if Mega Menu should be 1 Level and in 2 ul's

            /* $( ".sub-menu" ).each(function(){
                if ($(this).children('li').length > 10) {
                        // CSS3 columns are not allowed.
                        // Add a wrapper div and split into two lists, and float them using CSS.
                        listElements = $(this).children('li');

                        itemCount = listElements.length - 10;

                        leftColumn = listElements.slice(0, 10).clone();
                        rightColumn = listElements.slice(itemCount).clone();
                        //$(this).wrap('<div class="sub-menu">');
                        parentDiv = $(this).parent();
                    $(this).remove();
                        $(leftColumn).appendTo(parentDiv).wrapAll('<ul class="sub-menu" />');
                        $(rightColumn).appendTo(parentDiv).wrapAll('<ul class="sub-menu" />');
                }
            }); */




            // Mobile mega menu

            const mobileMegaMenuItem = $(".js--mobile-mega-menu");
            const mobileMegaMenuContent = $(".js--mobile-mega-menu-content");

            var menuOpened = false;



            /*for (let i = 0; i < mobileMegaMenuItem.length; i++) {
                mobileMegaMenuItem[i].addEventListener("click", (e) => {

                    if (!menuOpened) {
                        mobileMegaMenuItem[i].classList.add("active");
                        mobileMegaMenuContent[i].style.height = "100%";
                        menuOpened = true;
                    } else {
                        mobileMegaMenuItem[i].classList.remove("active");
                        mobileMegaMenuContent[i].style.height = "0";
                        menuOpened = false;
                    }
                });
            }*/





        },
        handle__archive: function () {







            // Custom dropdown




            // Search istop

            /*$(".search-items-parent .dd-option-text").click(function () {
                var data = "." + $(this).text().toLowerCase(); // <<<<<< dropdown item text
                var filterData = data.replace(" ", "-");
                if (filterData == ".select-filter") {
                    // <<<<< if dropdown item text == Select Filter
                    filterData = "*";
                }
                /!*$("#js--blog-search-list").isotope({
                    filter: filterData,
                });*!/
            });*/

            // search blog list
            const searchBlogInput = document.querySelector(".item-search-input input");
            const blogItem = document.querySelectorAll(".tall-blog-item");

            var searchInputValue;

            if (searchBlogInput !== null) {
                searchBlogInput.addEventListener("input", (e) => {
                    searchInputValue = e.target.value.toLowerCase();

                    if (searchInputValue == "") {
                        for (let i = 0; i < blogItem.length; i++) {
                            blogItem[i].style.display = "block";
                        }
                    }

                    for (let i = 0; i < blogItem.length; i++) {
                        var blogItemTitle = blogItem[i].getElementsByTagName("h3")[0];

                        /*$("#js--blog-search-list").isotope({
                            filter: "*", //  cancel dropdown filtering
                        });*/

                        if (blogItemTitle.innerHTML.toLowerCase().indexOf(searchInputValue) != -1) {
                            blogItem[i].style.display = "block";
                        } else {
                            blogItem[i].style.display = "none";
                        }
                    }
                });
            }
        },
        handle__videos: function () {

            $(".btn-play").on( "click", function(e) {
                e.preventDefault();

                var videoid = this.className.replace('btn-play js-play-', '');;

                var iframe = $('#' + videoid ).find('iframe');

                this.remove();
                $('.poster-' + videoid ).remove();
                iframe[0].src += "&autoplay=1";
            });

        },
        handle__masonry: function () {
            /**
             * Masonry layout
             */

            $(window).on('load', () => {

                initMasonry();

            });


            const initMasonry = () => {

                if (!$('.js-masonry').length) {
                    return;
                }

                const masonryGrid = new Masonry('.js-masonry', {
                    columnWidth: '.gallery__item',
                    percentPosition: true,
                });
            }
        },
    };


    let Elementor_N49 = {
        initHeroSlider: function () {
            function slider(direction) {
                const swiper = new Swiper(".js--swiper", {
                    // Optional parameters
                    direction: direction,
                    loop: true,

                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                });
            }

            function mobileSLider(x) {
                if (x.matches) {
                    slider("horizontal");
                } else {
                    slider("vertical");
                }
            }

            var x = window.matchMedia("(max-width: 700px)");
            mobileSLider(x);
            x.addListener(mobileSLider);

// Galery slider
            const swiper = new Swiper(".js--mobile-gallery-slider", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });

        },
    };


    N49.init();


    $(window).on('elementor/frontend/init', function () {
        //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
        //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
        //$scope is a jquery wrapped parent element

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__hero.default', function ($scope, $) {
            Elementor_N49.initHeroSlider();
        });



    });


}(jQuery));